import { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useMyBackups(token, view, refreshKey) {
  const [list, setList] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () => axios.get(`${API}/dialer/pc-backups/mine`, { headers: { Authorization: `Bearer ${token}` }, params: { view }, timeout: 30000 })
      .then((r) => { if (alive) setList(r.data?.backups || []); }).catch(() => { if (alive) setList([]); });
    load();
    // Pick up assignments, revokes and expiry without a page reload.
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [token, view, refreshKey]);
  return list;
}

export const BackupBanner = ({ name, testid = "pc-backup-banner", children }) => (
  <div data-testid={testid} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 12px", borderRadius: 8, background: "#EDE9FE", border: "0.5px solid #C4B5FD", color: "#4C1D95", fontSize: 12, fontWeight: 600 }}>
    <Users style={{ width: 14, height: 14 }} /> {children || <>Working as backup for {name}</>}
  </div>
);

export function BackupSelector({ backups, value, onChange, myCount }) {
  if (!backups.length) return null;
  const sel = backups.find((b) => b.owner_id === value);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {sel ? <BackupBanner name={sel.owner_name} /> : (
        <BackupBanner testid="pc-backup-assigned-banner">
          You&apos;ve been assigned as backup for {backups.map((b) => b.owner_name).join(", ")} — pick their campaign below.
        </BackupBanner>
      )}
      <select data-testid="pc-campaign-selector" value={value} onChange={(e) => onChange(e.target.value)}
        style={{ fontSize: 12, padding: "6px 9px", border: "0.5px solid #c9d0d8", borderRadius: 6, background: "white", maxWidth: 360 }}>
        <option value="">My Personal Campaign{myCount != null ? ` (${myCount})` : ""}</option>
        {backups.map((b) => <option key={b.owner_id} value={b.owner_id}>{b.owner_name}&apos;s Campaign (backup) ({b.count})</option>)}
      </select>
    </div>
  );
}
